// ISO 3166-1 alpha-2 ülke listesi + ülke tespiti. Kayıt formu (auth.tsx) ve Faturalandırma
// (FaturalandirmaPage.tsx) kullanır. Ülke adları tarayıcının Intl.DisplayNames'inden gelir.
export const COUNTRY_CODES = ('AF AX AL DZ AS AD AO AI AQ AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BQ BA BW BV BR IO BN BG BF BI CV KH CM CA KY CF TD CL CN CX CC CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF TF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT HM VA HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI KP KR KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU NF MK MP NO OM PK PW PS PA PG PY PE PH PN PL PT PR QA RE RO RU RW BL SH KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA GS SS ES LK SD SR SJ SE CH SY TW TJ TZ TH TL TG TK TO TT TN TR TM TC TV UG UA AE GB US UM UY UZ VU VE VN VG VI WF EH YE ZM ZW').split(' ');

export function countryOptions(lang: string): { code: string; name: string }[] {
  let dn: any = null;
  try { dn = new (Intl as any).DisplayNames([lang === 'en' ? 'en' : 'tr'], { type: 'region' }); } catch {}
  const loc = lang === 'en' ? 'en' : 'tr';
  return COUNTRY_CODES
    .map(code => ({ code, name: (dn && dn.of(code)) || code }))
    .sort((a, b) => a.name.localeCompare(b.name, loc));
}

// Kayıt formunda varsayılan seçim için tahmin: saat dilimi (İstanbul → TR), yoksa tarayıcı dilinin bölgesi.
export function detectCountry(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz === 'Europe/Istanbul' || tz === 'Asia/Istanbul') return 'TR';
    const m = (navigator.language || '').match(/[-_]([A-Za-z]{2})$/);
    if (m) {
      const c = m[1].toUpperCase();
      if (COUNTRY_CODES.includes(c)) return c;
    }
  } catch {}
  return '';
}
